export const createWrapper = () => {
    const wrapper = document.createElement('div');
    wrapper.className = 'tg-wrapper';

    return wrapper;
};
